define('plugin/package/model/PackageOrderModel',['require','lib/model/BaseModel','plugin/invoice/model/InvoiceModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');

    /**
     * Package order data model
     *
     * @class PackageOrderModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/package/order/id/',

        defaults: {
            id: null,
            package_id: null,
            invoice: null
        },

        parse: function (resp, options) {
            var result = BaseModel.prototype.parse.apply(this, [resp, options]);
            if (result.invoice) {
                result.invoice = new InvoiceModel(result.invoice);
            }

            return result;
        }

    });

});
